import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import colors from '../util/colors';
import breakpoints from '../util/breakpoints';

const Button = styled('div', {shouldForwardProp: prop => isPropValid(prop)})(props => ({
  background: props.primary
    ? props.theme.btnBG || props.theme.primaryAccent || props.theme.primary
    : props.theme.secondary,
  minWidth: props.minWidth || 'none',
  borderRadius: props.theme.gameRadius || props.theme.radius || `5px`,
  cursor: `pointer`,
  display: `inline-flex`,
  justifyContent: `center`,
  textAlign: 'center',
  fontWeight: 'bold',
  alignItems: `center`,
  padding: '5px 12px',
  boxSizing: 'border-box',
  margin: `0px 2px`,
  fontSize: `18px`,
  color: colors.ultraLight,
  border: `1px solid ${props.theme.outlineUnfocused}`,
  a: {
    color: colors.light,
    textDecoration: `none`
  },
  [`svg, div`]: {
    margin: `0px 5px`
  },
  [`:hover`]: {
    background: props.primary
      ? props.theme.btnBG || props.theme.primaryAccent || props.theme.primary
      : null,
    border: `1px solid ${props.theme.outlineFocused}`
  },
  [breakpoints.sm]: {
    width: props.dontExpand ? 'auto' : '100%'
  }
}));

export default Button;
